
import { defineComponent } from 'vue'
import { useExplainProductAnalysisAction } from '../../../composables/explain/use-explain-product-analysis-action'
import { EpbButton } from '../../shared/epb-button'

export default defineComponent({
  name: 'NavigateToExplainSearchButton',
  components: {
    EpbButton,
  },
  setup() {
    const { navigateToExplainSearch } = useExplainProductAnalysisAction()

    return {
      navigateToExplainSearch,
    }
  },
})
